export type ViewType =
  | 'sign_in'
  | 'sign_up'
  | 'forgotten_password'
  | 'magic_link'
  | 'update_password';

interface ViewsMap {
  [key: string]: ViewType;
}

export const VIEWS: ViewsMap = {
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  FORGOTTEN_PASSWORD: 'forgotten_password',
  MAGIC_LINK: 'magic_link',
  UPDATE_PASSWORD: 'update_password',
};

interface ErrorType {
  [key: string]: string;
}
export class AuthValidationError extends Error {
  public errors: ErrorType = {};
  constructor(message: string, errors: ErrorType) {
    super(message);
    this.name = 'AuthValidationError';
    this.errors = errors;
  }
}
